import store from "./../store/store";

export default function getLabel(labelName) {
    let labels = store.getState().uiState.defaultStrings;
    if (labels.length > 0) {
        return labels.find(item => item.label_key === labelName).label_value;
    }
}


// WEBPACK FOOTER //
// /src/utils/labels.js